<template>
    <ol class="v-breadcrumbs">
        <li
            :class="{ 'v-breadcrumbs__divider' : crumb.disabled == true}"
            v-for="(crumb) in breadcrumbPathWithDividers"
        >
            <router-link
                :to="crumb.to"
                class="v-breadcrumbs__item"
                v-if="crumb.to != undefined"
            >
                {{ crumb.text }}
            </router-link>
            <router-link
                class="divider"
                event=""
                to=""
                v-else
            >
                /
            </router-link>
        </li>
    </ol>
</template>

<script>
    export default {
        name: 'BreadCrumb',
        props: {
            items: {
                type: Array,
                default() {
                    return []
                }
            }
        },

        computed: {
            breadcrumbPathWithDividers() {
                if (this.items !== undefined) {
                    let arrayLength = this.items.length;
                    let newArray = [];
                    for (let i = 0; i < arrayLength; i++) {
                        newArray.push(this.items[i]);
                        if (i < arrayLength - 1) {
                            newArray.push({text: '/', disabled: true});
                        }
                    }
                    return newArray;
                }
                return [];
            }
        },

        mounted() {
            // console.log(this.items);
        }
    };
</script>

<style scoped>
    .divider {
        pointer-events: none;
        cursor: default;
        text-decoration: none;
        color: rgba(0, 0, 0, .38);
    }
</style>
